<template>
  <div class="content">
    <div class="middled">
      <div class="row searchrow">
        <div class="column">
          <div class="breadcrumbs">
            <router-link class="small-hider" :to="{ name: 'dashboards'}">Dashboards</router-link>
            <span v-if="$route.params.scorecard_id"> > <router-link :to="{ name: 'scorecard', params: { scorecard_id: $route.params.scorecard_id }}">Scorecard</router-link></span>
            <span v-if="$route.params.category_id"> > <router-link :to="{ name: 'category', params: { scorecard_id: $route.params.scorecard_id, category_id: $route.params.category_id }}">Category</router-link></span>
            <span v-if="$route.params.measure_id"> > <router-link :to="{ name: 'measure', params: { scorecard_id: $route.params.scorecard_id, category_id: $route.params.category_id, measure_id: $route.params.measure_id }}">Measure</router-link></span>
            <span v-if="$route.query.task_description"> > {{ $route.query.task_description }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div v-if="!hasAllParams" class="taskwork-error">
            <h2>Missing Information</h2>
            <p>Sorry, we couldn't load this task chat because some required information is missing from the URL.</p>
            <router-link :to="{ name: 'scorecard', params: { scorecard_id: $route.params.scorecard_id } }" class="back-link">&larr; Go back to the task list</router-link>
          </div>
          <TaskWork
            v-else
            :task="taskObj"
            :scid="$route.params.scorecard_id"
            :cid="$route.params.category_id"
            :mid="$route.params.measure_id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TaskWork from '@/components/includes/TaskWork.vue';

export default {
  name: 'TaskWorkChat',
  components: { TaskWork },
  computed: {
    hasAllParams() {
      return (
        this.$route.params.scorecard_id &&
        this.$route.params.category_id &&
        this.$route.params.measure_id &&
        this.$route.params.task_id
      );
    },
    taskObj() {
      // Compose a minimal task object for TaskWork
      return {
        task_id: this.$route.params.task_id,
        task_description: this.$route.query.task_description || ''
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.taskwork-error {
  background: #fff3f3;
  border: 1px solid #ffd6d6;
  border-radius: 8px;
  padding: 32px 24px;
  margin: 40px auto;
  max-width: 480px;
  text-align: center;
  color: #b00020;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.taskwork-error h2 {
  margin-bottom: 12px;
  font-size: 1.5rem;
}
.taskwork-error .back-link {
  display: inline-block;
  margin-top: 18px;
  color: #0077cc;
  text-decoration: underline;
  font-weight: 500;
  font-size: 1.1rem;
}
</style>